import * as React from "react";

import { nullToEmpty } from "@impero-com/common/utils/string";

import * as theme from "./theme.css";

class ModernTabs extends React.PureComponent<ModernTabsProps> {
    render() {
        const { tabs, className, onChange, tabIndex } = this.props;
        return (
            <div>
                <div
                    className={`${theme.modernTabsHeader} ${nullToEmpty(
                        className
                    )}`}
                >
                    {tabs.map((tab, index) => (
                        <div
                            key={index}
                            className={
                                index === tabIndex
                                    ? theme.modernTabHeaderSelected
                                    : theme.modernTabHeader
                            }
                            onClick={
                                tabIndex !== index
                                    ? () => onChange(index, tabIndex)
                                    : undefined
                            }
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>
                <div
                    className={
                        tabIndex < tabs.length
                            ? tabs[tabIndex].className
                            : undefined
                    }
                >
                    {tabIndex < tabs.length ? tabs[tabIndex].getData() : null}
                </div>
            </div>
        );
    }
}

interface ModernTabsProps {
    tabs: Array<ModernTab>;
    tabIndex: number;
    className?: string;
    onChange: (tabIndex: number, oldIndex: number) => void;
}

interface ModernTab {
    label: string;
    getData: () => React.ReactNode;
    className?: string;
}

export { ModernTabs, type ModernTabsProps, type ModernTab };
